export const AdminCustomersRiskDashboards = {
  AdminCustomersRiskDashboards: {
    permissionsId: "1f2b1fe6-a4ab-4ac2-286b-08dbaf79a1bb",
    permissionsName: "Customer Risk",
    description: null,
    componentsId: null,
    components: null
  },
};
